import styled from 'styled-components';
import { themeGet } from 'styled-system';

import { LayoutBox } from 'src/kit';
// you can move it directly to feed/filter component
// after redesign of / pages / magazines / resources pages
export const FiltersWrapper = styled(LayoutBox)`
  flex: 0 2 300px;
  margin-top: -20px;
  padding-right: 30px;
  padding-bottom: 30px;
  position: sticky;
  top: 90px;
  align-self: flex-start;
  max-height: calc(100vh - 110px);
  overflow-y: auto;

  .list-wrapper {
    overflow: auto;
    max-height: calc(100vh - 420px);
  }

  .track-0 {
    background: ${themeGet('colors.cloudyBlueTwo')};
  }
  .track-1 {
    background: ${themeGet('colors.primary')};
  }
  .track-2 {
    background: ${themeGet('colors.cloudyBlueTwo')};
  }

  @media (max-width: 1024px) {
    flex: 1 1 100% !important;
    width: 100%;
    min-width: 100%;
    max-width: 100%;
    padding-right: 25px;
    padding-left: 25px;
    margin-top: 0;
    position: static;
    max-height: none;
    overflow-y: visible;
  }

  @media (max-width: 768px) {
    padding-right: 12.5px;
    padding-left: 12.5px;
  }

  @media (max-width: 578px) {
    padding-right: 5px;
    padding-left: 5px;
  }
`;
